<template>
  <div class="modal fade" id="modal_aluno" aria-modal="true" role="dialog">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="fw-bolder">Inserir aluno ao Projeto</h2>
          <div id="modal_novo_aluno_close" class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
            <span class="svg-icon svg-icon-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="black"></rect>
                <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="black"></rect>
              </svg>
            </span>
          </div>
        </div>
        <div class="modal-body scroll-y" id="modal_aluno_body">
          <div class="rounded border p-5 mb-5">
            <div class="d-flex flex-stack">
              <div class="me-5">
                <label class="fs-6 fw-bold form-label">Não encontrou o aluno que procura?</label>
                <div class="fs-7 fw-bold text-muted">Cadastre ou busque um aluno clicando ao lado!</div>
              </div>
              <label class="form-check form-switch form-check-custom form-check-solid">
                <input class="form-check-input" type="checkbox" v-model="cadastro"/>
                  <span class="form-check-label fw-bold text-muted" v-if="!cadastro">Clique para cadastrar</span>
                  <span class="form-check-label fw-bold text-muted" v-else>Clique para buscar</span>
              </label>
            </div>
          </div>

          <form class="form d-flex flex-column flex-lg-row fv-plugins-bootstrap5 fv-plugins-framework m-0"
              novalidate="novalidate"
              @submit.prevent="submit">
            <form-body :loading="form.processing || loading" :form="form" :addClass="'p-5'">
              <div class="row">
                <div class="col-12" :class="{'d-none': cadastro}">
                  <form-group label="Aluno" required>
                    <select class="form-select" data-control="select2"
                            data-dropdown-parent="#modal_aluno" v-select2
                            data-placeholder="Selecione um Aluno"
                            v-model="model.id"
                            @change="atualizaAluno()">
                      <option></option>
                      <option v-for="aluno in alunos" :value="aluno.id" >{{ aluno.nome }}</option>
                    </select>
                  </form-group>
                </div>

                <div class="col-12" v-if="cadastro">
                  <form-group label="Aluno" required :is-invalid="model.errors.AlunoNome">
                    <input
                        class="form-control mb-2"
                        type="text"
                        placeholder="Nome do Aluno"
                        v-model="model.AlunoNome"
                        @blur="model.clearErrors('AlunoNome')"
                        :class="{'is-invalid' : model.errors.AlunoNome}"
                        maxlength="120"
                    />
                  </form-group>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col">
                  <form-group label="Email" required :is-invalid="model.errors.AlunoEmail">
                    <input
                        class="form-control mb-2"
                        type="text"
                        placeholder="Nome do Email"
                        v-model="model.AlunoEmail"
                        @blur="model.clearErrors('AlunoEmail')"
                        :class="{'is-invalid' : model.errors.AlunoEmail}"
                        maxlength="120"
                    />
                  </form-group>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col">
                  <form-group label="Telefone" required :is-invalid="model.errors.AlunoTelefone">
                    <input
                        v-model="model.AlunoTelefone"
                        class="form-control mb-2"
                        type="text"
                        placeholder="Telefone"
                        v-input-mask
                        data-inputmask="'mask': '(99) 9 9999-9999', 'placeholder': '', 'removeMaskOnSubmit': true, 'showMaskOnHover': false, 'showMaskOnFocus': false"
                        @blur="model.clearErrors('AlunoTelefone')"
                        :class="{'is-invalid' : model.errors.AlunoTelefone}"
                        maxlength="120"
                    />
                  </form-group>
                </div>

                <div class="col">
                  <form-group label="CPF" required :is-invalid="model.errors.AlunoCPF">
                    <input
                        class="form-control mb-2"
                        type="text"
                        placeholder="CPF"
                        v-input-mask
                        data-inputmask="'mask': '999.999.999-99', 'placeholder': '', 'removeMaskOnSubmit': true, 'showMaskOnHover': false, 'showMaskOnFocus': false"
                        v-model="model.AlunoCPF"
                        @blur="model.clearErrors('AlunoCPF')"
                        :class="{'is-invalid' : model.errors.AlunoCPF}"
                        maxlength="120"
                    />
                  </form-group>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-6">
                  <form-group label="Camiseta" required :is-invalid="model.errors.AlunoCamiseta">
                    <select class="form-select"
                            v-model="model.AlunoCamiseta"
                            @blur="model.clearErrors('AlunoCamiseta')"
                            :class="{'is-invalid' : model.errors.AlunoCamiseta}">
                      <option value="P">P</option>
                      <option value="M">M</option>
                      <option value="G">G</option>
                      <option value="GG">GG</option>
                    </select>
                  </form-group>
                </div>

                <div class="col-6">
                  <form-group label="Gênero" required :is-invalid="model.errors.AlunoGenero">
                    <select class="form-select"
                            v-model="model.AlunoGenero"
                            @blur="model.clearErrors('AlunoGenero')"
                            :class="{'is-invalid' : model.errors.AlunoGenero}">
                      <option value="F">Feminino</option>
                      <option value="M">Masculino</option>
                      <option value="O">Outro</option>
                    </select>
                  </form-group>
                </div>
              </div>
            </form-body>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {useForm} from "@inertiajs/inertia-vue3";
import FormGroup from "@forms/FormGroup";
import FormBody from "@forms/FormBody";
import axios from "axios";

export default {
  components: {
    FormGroup,
    FormBody
  },
  data: _ => ({
    model: {},
    loading: false,
    alunos: [],
    aluno: {},
    cadastro: false,
  }),

  setup() {
    const form = useForm({id: null,
      AlunoNome: null, AlunoCamiseta: null, AlunoGenero: null,
      AlunoEmail: null, AlunoCPF: null, AlunoTelefone: null
    })
    return {form};
  },

  created() {
    this.model = this.form

    axios.get(this.route('app.core.alunos')).then(response => {
      this.alunos = response.data
    })
  },

  methods: {
    atualizaAluno() {
      this.aluno = this.alunos.find(aluno => aluno.id === parseInt(this.model.id))
      this.model.AlunoCPF = this.aluno.cpf
      this.model.AlunoNome = this.aluno.nome
      this.model.AlunoCamiseta = this.aluno.camiseta
      this.model.AlunoGenero = this.aluno.genero
      this.model.AlunoCPF = this.aluno.cpf
      this.model.AlunoEmail = this.aluno.email
      this.model.AlunoTelefone = this.aluno.telefone

      if (!this.aluno.incompleto) {
        //Faço isso para que o form entenda que este é o novo padrão ao selecionar um usuário
        //Dessa forma o isDirty fica nulo
        this.model.defaults({
          'id': this.aluno.id,
          'AlunoNome': this.aluno.nome,
          'AlunoCamiseta': this.aluno.camiseta,
          'AlunoGenero': this.aluno.genero,
          'AlunoCPF': this.aluno.cpf,
          'AlunoEmail': this.aluno.email,
          'AlunoTelefone': this.aluno.telefone,
        });
      }
    },

    closeModal() {
      this.cadastro = false
      this.form.reset()
      this.loading = false

      document.getElementById('modal_novo_aluno_close').click();
    },

    async submit() {
      this.loading = true
      let route = 'app.alunos.json.update';

      if (this.cadastro) {
        route = 'app.alunos.json.store'
      }

      if (this.form.isDirty || this.cadastro) {
        await axios.post(this.route(route), this.form).then(response => {
          this.$parent.adicionaAluno(response.data)
          this.closeModal()
        }).catch(error => {
          this.loading = false

          Object.entries(error.response.data.errors).forEach(([key, value]) => {
            this.form.setError(key, `${value}`)
          })
        })
      } else {
        this.$parent.adicionaAluno(this.aluno)
        this.resetForm()
      }
    },
    resetForm() {
      this.loading = false
      this.aluno = {}
      this.form.defaults({id: null,
        AlunoNome: null, AlunoCamiseta: null, AlunoGenero: null,
        AlunoEmail: null, AlunoCPF: null, AlunoTelefone: null
      })
      this.form.reset()
      this.form.clearErrors()
    }
  },
  watch: {
    cadastro() {
      this.resetForm()
    }
  }
}
</script>